// extracted by mini-css-extract-plugin
module.exports = {"margin_left_20":"EligibilityQuestionFishingTruck_margin_left_20__1NYBa","margin_back":"EligibilityQuestionFishingTruck_margin_back__eGE-U"};